import { useState, useEffect } from "react";
import { saveCostCenter, getAllDepartments } from "../Api/CostCenterMaster";
import { Container, Form, Button, Row, Col } from "react-bootstrap";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Sample14 from "../Components/Logo";

const CostCenterMaster = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [departments, setDepartments] = useState([]);
  const [departmentLoading, setDepartmentLoading] = useState(true);
  const userDetails = JSON.parse(localStorage.getItem("userDetails"));
  const userId = userDetails?.userId;

  const [costCenterData, setCostCenterData] = useState({
    costCenterCode: "",
    costCenterName: "",
    department: "", 
    status: "Active", 
  });

  // Fetch departments on component mount
  useEffect(() => {
    const fetchDepartments = async () => {
      try {
        const data = await getAllDepartments();
        setDepartments(data);
        setDepartmentLoading(false);
      } catch (error) {
        toast.error(`🦄 Error loading departments: ${error.message}`);
        setDepartmentLoading(false);
      }
    };
    fetchDepartments();
  }, []);

  const handleChange = (e) => {
    setCostCenterData({ ...costCenterData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await saveCostCenter(costCenterData, userId);
      toast.success(`🦄 Cost Center Added Successfully`);
      setCostCenterData({
        costCenterCode: "",
        costCenterName: "",
        department: "",
        status: "Active",
      });
      navigate("/costCenterMaster");
    } catch (error) {
      toast.error(`🦄 Error saving cost center: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  return (
      <div className="main-content expand">
        <Container fluid className="fields-container">
          <h2 className="fields-title">Cost Center Master</h2>

          {loading && (
            <div className="loading-overlay">
              <Sample14 />
            </div>
          )}

          <Form onSubmit={handleSubmit} className="fields-form">
            <Row>
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>Cost Center Code <span className="text-red">**</span></Form.Label>
                  <Form.Control
                    type="text"
                    name="costCenterCode"
                    value={costCenterData.costCenterCode}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>Cost Center Name <span className="text-red">**</span></Form.Label>
                  <Form.Control
                    type="text"
                    name="costCenterName"
                    value={costCenterData.costCenterName}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>Department <span className="text-red">**</span></Form.Label>
                  <Form.Select
                    name="department"
                    value={costCenterData.department}
                    onChange={handleChange}
                    required
                    disabled={departmentLoading}
                  >
                    <option value="">Select Department</option>
                    {departments.map((dept) => (
                      <option key={dept.code} value={dept.code}>
                        {dept.code} - {dept.description}
                      </option>
                    ))}
                  </Form.Select>
                  {departmentLoading && (
                    <small className="text-muted">Loading departments...</small>
                  )}
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>Cost Center Status <span className="text-red">**</span></Form.Label>
                  <Form.Select
                    name="status"
                    value={costCenterData.status}
                    onChange={handleChange}
                    required
                  >
                    <option value="Active">Active</option>
                    <option value="Inactive">Inactive</option>
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>

            <div className="fields-btn-container">
              <Button
                variant="primary"
                type="submit"
                className="fields-submit"
                disabled={loading || departmentLoading}
              >
                {loading ? "Saving..." : "Save Cost Center"}
              </Button>
            </div>
          </Form>
        </Container>
      </div>
  );
};

export default CostCenterMaster;